export const ClassTypes = ['On-Site', 'Virtual'];
